<template>
  <div ref="nameContent">
    <v-tooltip
      color="#384955"
      top
      :disabled="!isOver"
      :max-width="500"
      content-class="name-section"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          class="name-content"
          v-bind="attrs"
          :class="{ active: !loading }"
          v-on="on"
        >
          <Typography :variant="isActive ? 'subtitle-2' : 'body-2'">{{
            name
          }}</Typography>
        </div>
      </template>
      <span>{{ name }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import Typography from '@/components/v3/base/Typography';

export default {
  name: 'TitleItem',
  components: {
    Typography,
  },

  props: {
    name: String,
    isActive: Boolean,
  },

  data() {
    return {
      loading: true,
      isOver: false,
    };
  },

  mounted() {
    setTimeout(() => {
      this.checkTextOver();
    }, 10);
  },

  methods: {
    checkTextOver() {
      this.loading = true;
      this.isOver = false;
      if (
        this.$refs.nameContent &&
        this.$refs.nameContent.scrollWidth > this.$refs.nameContent.clientWidth
      ) {
        this.isOver = true;
      }
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scope>
.name-content {
  font-size: 14px;
  color: #384955;
  letter-spacing: 0.2px;
  text-transform: capitalize;
  white-space: nowrap;
  &.active {
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.v-tooltip__content {
  font-size: 12px;
}
</style>
